import { render, staticRenderFns } from "./Odlocbe.vue?vue&type=template&id=82947fb4&"
import script from "./Odlocbe.vue?vue&type=script&lang=js&"
export * from "./Odlocbe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports